import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import brandsData from "../data/brands.json";

export default function BrandsCard({ brand }) {
  const { i18n } = useTranslation();
  const fallbackBrand = brandsData[brand.handle];
  const logoSrc = fallbackBrand?.logo || brand.metadata?.logo;
  const displayTitle = brand.title || fallbackBrand?.title || brand.handle;

  const path =
    i18n?.language === "en"
      ? `/en/brands/${brand.handle}`
      : `/sr/brendovi/${brand.handle}`;
  return (
    <div className="col-lg-2 col-md-6 col-6 mb-20">
      <div className="logo-item">
        <div className="grid-figure">
          <div className="logo-img">
            <Link title={displayTitle} to={path}>
              {logoSrc ? (
                <img src={logoSrc} alt={displayTitle} title={displayTitle} />
              ) : (
                <div
                  style={{
                    minHeight: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "20px",
                    color: "#d8b25a",
                    fontWeight: 600,
                    letterSpacing: "0.04em",
                  }}
                >
                  {displayTitle}
                </div>
              )}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
